module.exports = __webpack_public_path__ + "img/ag.7fde9e1b.svg";